// extracted by mini-css-extract-plugin
export default {"scrollContainer":"ReceiptsGrid_scrollContainer__ZGBPn"};